import { Route, Routes } from 'react-router';
import BatchPage from './_pages/BatchPage';
import BatchesPage from './_pages/BatchesPage';

export const BatchRoutes = () => {
  return (
    <Routes>
      <Route index element={<BatchesPage />} />
      <Route path="/:id" element={<BatchPage />} />
    </Routes>
  );
};
